import {ContentContainer} from '@components/lib'

import PortfolioChart from 'containers/PortfolioChart'
import WalletAssets from 'components/WalletAssets'
import LabelCryptoApi from 'components/LabelCryptoApi'

import WalletMfaDownloadInfoBox from '../WalletMfaDownloadInfoBox'
import WalletMfaActivateInfoBox from '../WalletMfaActivateInfoBox'

import {Grid, CellChart, CellAssets} from './WalletMain.styles'

const WalletMain = () => (
  <ContentContainer withNavPadding>
    <LabelCryptoApi />
    <Grid>
      <CellChart>
        <PortfolioChart />
        <WalletMfaDownloadInfoBox />
        <WalletMfaActivateInfoBox />
      </CellChart>
      <CellAssets>
        <WalletAssets />
      </CellAssets>
    </Grid>
  </ContentContainer>
)

export default WalletMain
